export default {"src":"/_next/static/media/importance_icon.c93c15c4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};